import { render, staticRenderFns } from "./BgCircle.vue?vue&type=template&id=540d25cd&scoped=true&"
import script from "./BgCircle.vue?vue&type=script&lang=js&"
export * from "./BgCircle.vue?vue&type=script&lang=js&"
import style0 from "./BgCircle.vue?vue&type=style&index=0&id=540d25cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540d25cd",
  null
  
)

export default component.exports